// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2110":"1dd88128","3888":"f2dbd2b4","4439":"5cf1e7f5","5693":"03a59d05","6451":"a195f43a"}[chunkId] + ".chunk.css";
};